/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AufgabeEskalationNotification { 
    titel?: string;
    eskalation_zeitpunkt_utc?: Date;
    data?: { [key: string]: string; };
    aufgabe_id: string;
    aufgabe_titel: string;
    text?: string;
    checkliste_id: string;
    checkliste_titel: string;
    funktionsbereich_id: string;
    funktionsbereich_titel: string;
    mandant_id: string;
    veranstaltung_id: string;
    veranstaltung_titel?: string;
    notification_type?: string;
}

